import React from "react";
import { drawPaletteGroup } from "./CanvasMicropalette"; // non-react lib
// import VisibilitySensor from 'react-visibility-sensor';

/**
 * A React wrapper for a canvas micropalette grouping renderer
 */
export default class Micropalette extends React.Component {

    constructor(props) {
        super(props);

        this.state = {}
        // this.onChange = this.onChange.bind(this);
        this.renderCanvas = this.renderCanvas.bind(this);
        this.draw = this.draw.bind(this);

        this.load = this.load.bind(this);
        this.unload = this.unload.bind(this);

        // using getCanvas() instead to prevent 
        // interacting with this.el directly from elsewhere
        // this.el = React.createRef();
        this.getCanvas();

        this.getCanvas = this.getCanvas.bind(this);
    }

    // required defaults
    static defaultProps = {
        height: 100,
        paletteWidth: 10,
        padding: 2,
        proportional: true,
        palettes: [],
        vertical: false,
        itemCount: 0
    }


    draw() {


        if (!this.getCanvas()) { return; }

        const canvas = this.getCanvas();

        canvas.classList.add("drawing");
        canvas.classList.remove("done");

        if (this.props.palettes.length < 1) { return }

        const { height, paletteWidth, padding, proportional, palettes, itemCount } = this.props;

        const canvasID = `canvas-${this.props.id}-${height}-${paletteWidth}-${padding}-${window.devicePixelRatio}`;

        const vertical = this.props.vertical;

        var canvasDataURL;
        if (this.props.useCache === true) {
            sessionStorage.getItem(canvasID);
        }

        // const width = (paletteWidth + padding) * palettes.length;
        // canvas.style.height = height + "px";

        if (!canvasDataURL) {
            try {
                drawPaletteGroup({
                    canvas,
                    height,
                    paletteWidth,
                    padding,
                    proportional,
                    palettes,
                    vertical
                });
            } catch (e) {
                console.error("Caught error trying to draw", this.props.id, e)
                return;
            }



            if (this.props.useCache === true) {
                sessionStorage.setItem(canvasID, canvas.toDataURL());
            }
            canvasDataURL = sessionStorage.getItem(canvasID);

        } else {
            const img = new Image();
            const width = (paletteWidth + padding) * (itemCount);
            canvas.style.width = width + "px";
    
            img.src = canvasDataURL;
            img.onload = () => {
                canvas.height = height * (window.devicePixelRatio || 1);
                canvas.width = width * (window.devicePixelRatio || 1);
                canvas.style.width = width + "px";
                canvas.style.height = height + "px";
                canvas.getContext('2d').drawImage(img, 0, 0);

            }

        }

        // this.el.current().addEventListener("mousemove", () => { console.log("Mousemove") });
        canvas.classList.remove("drawing")
        canvas.classList.add("done");

    }

    componentDidUpdate(newProps) {
        this.draw();
    }

    componentDidMount() {
        // if(!this.state.visible){ return; }
        this.draw();

    }

    componentWillUnmount() {
        this.unload();
    }

    load() {
    }

    unload() {
        if (this.getCanvas()) {
            this.getCanvas().setAttribute("width", 0)
            this.getCanvas().setAttribute("height", 0)
            this.el = null
            // this.el = React.createRef();
        }

    }

    // onChange(isVisible) {
    //     this.setState({ "visible": isVisible })
    //     if (isVisible) { this.load(); }
    //     else {
    //         this.unload();
    //     }
    // }

    getCanvas() {
        if (!this.el) {
            this.el = React.createRef();
        }
        return this.el.current;
    }

    renderCanvas() {
        return <canvas ref={this.el} />
        // return <canvas ref={el => this.el = this.el || el}></canvas>
    }

    render() {

        if (this.props.palettes.length > 0) {
        }


        if (this.props.palettes.length < 1) { return (null) }
        const width = (this.props.padding + this.props.paletteWidth) * this.props.palettes.length;
        const height = this.props.height;
        return (
            // <VisibilitySensor partialVisibility={true} onChange={this.onChange}>
            <div id={this.props.id} className="Micropalette"
                style={{
                    width: (this.props.vertical ? height : width) + "px",
                    height: (this.props.vertical ? width : height) + "px"
                }}>
                {this.renderCanvas()}
            </div>
            // </VisibilitySensor>
        )
    }
}